module.exports = __webpack_public_path__ + "static/media/100-10-1-welcome4.b8fe6c36.jpg";